import type { TestSetParameters } from "@/types/backend-contracts"
import type { JsonObject } from "@/types/json"
import type { TestCaseInput } from "@/types/TestCaseInput"

export enum TestSetType {
  DEFAULT = "DEFAULT",
  STREAM = "STREAM",
  TRANSCRIPT = "TRANSCRIPT",
  SCENARIO = "SCENARIO",
  WORKFLOW = "WORKFLOW",
  IVR = "IVR",
  AUDIO = "AUDIO",
  SCRIPT = "SCRIPT",
}

const TEST_SET_TYPE_VALUES = new Set<string>(Object.values(TestSetType))

export function isTestSetType(
  value: string | null | undefined,
): value is TestSetType {
  return value != null && TEST_SET_TYPE_VALUES.has(value)
}

export interface TestSetInput {
  display_name: string
  test_set_metadata?: JsonObject
  description: string
  test_set_type: TestSetType
  testCases: TestCaseInput[]
  parameters?: TestSetParameters
}
